export enum WorkspaceCapabilityCacheRevisionScope {
    domainAggregateTemplatesGetAll = "3f6edabe-ecdf-44f2-bf46-90f747034d1b",
    ottopilotEventContainerTemplatesGetAll = "c320d646-9fdd-498d-a8c8-4763cb62a8c3",
    ottopilotEventTemplatesGetAll = "d91346c5-9534-4355-a5a0-52f24bd3cfa1",
    organizationalUnitTemplatesGetAll = "bff215c3-9d2e-44d9-96a1-5ce710df082d",
    organizationalUnitsCountAll = "2655c2fa-b8fe-4df0-840a-b865efbf2da2",
    organizationalUnitsGetAll = "8e32455c-ce00-41b0-830e-6abb9f2591e9",
    productCatalogueTemplatesGetAll = "5ba53a4a-72e6-4ee8-abc9-9fcea8b2ace5",
    productCataloguesCountAll = "451b9327-bc35-4eb7-93db-b61763766eb8",
    productCataloguesGetAll = "b6d68e34-cb33-426b-bcd4-7de5d9566a37",
    tuffexProductCatalogueRowsCountAll = "bde82e19-4505-4e9c-9c56-d6bef68d47ee",
    tuffexProductCatalogueRowsGetAll = "2ae89710-db41-43f7-a1fc-2fcf63e3b82c",
};

export function normalizeWorkspaceCapabilityCacheInput(value: unknown): unknown {
    if (Array.isArray(value)) {
        return value.map(normalizeWorkspaceCapabilityCacheInput);
    }

    if (value !== null && typeof value === "object") {
        const normalizedObject: Record<string, unknown> = {};
        for (const [key, rawValue] of Object.entries(value).sort(([leftKey], [rightKey]) => {
            if (leftKey < rightKey) {
                return -1;
            }
            if (leftKey > rightKey) {
                return 1;
            }
            return 0;
        })) {
            const normalizedValue = normalizeWorkspaceCapabilityCacheInput(rawValue);
            if (normalizedValue !== undefined) {
                normalizedObject[key] = normalizedValue;
            }
        }
        return normalizedObject;
    }

    return value;
}
